<template>
  <div>
    <a-spin :spinning="spinning">
      <div class="map-wrapper">
        <div
          class="map-img"
          :style="{
            background: 'url(' + courseInfo.courseMap_url + ') no-repeat',
            backgroundSize: 'auto',
            height: '1000px',
          }"
        >
          <div
            v-for="(unit, index) in courseUnitResult.records"
            :key="unit.id"
            :class="['unit', unit.isOpen ? 'opened' : 'gray']"
            :style="{ left: unit.mapX - 25 + 'px', top: unit.mapY - 25 + 'px' }"
            @click="viewUnit(unit)"
          >
            <!-- <i class="flag" :class="[isPoint(index, unit) ? 'point' : '']">
            <img
              class="arrow"
              v-if="isPoint(index, unit)"
              src="@/assets/mycourse/arrow.svg"
              alt
            /> -->
            <img :src="'/static/img/map-ico/' + (index + 1) + '.png'" alt />
            <!-- </i> -->
          </div>
        </div>
      </div>
    </a-spin>
    <div
      class="enter-unit-wrap"
      v-if="showEnterModal"
      @click="showEnterModal = false"
    >
      <div class="enter-unit">
        <svg-icon class="badge" icon-class="badge" />
        <h1>你已完成{{ currentUnit.mineWorkId ? "100" : "0" }}%课程进度</h1>
        <div>
          <div @mouseover="isShowEnter = true">
            <svg-icon class="robot" icon-class="robot" />
          </div>
          <div
            class="percent"
            v-show="isShowEnter === true"
            @mouseleave="isShowEnter = false"
            @click="toUnit"
          >
            <div v-if="currentUnit.isOpen">
              <p>继续</p>
              <p>挑战</p>
            </div>
            <div v-else>未开课</div>
          </div>
        </div>
        <h1 v-if="currentUnit.isOpen">已开课</h1>
        <h1 v-else>{{ currentUnit.openTime }}开课</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { getStudentCourseUnit, getMineCourse } from "@/api/course";

export default {
  name: "MineUnitMap",
  components: {},
  data() {
    return {
      courseId: "",
      departId: "",
      courseInfo: {},
      courseUnitResult: {},
      currentUnit: {},
      finishedWork: [],
      unFinishedWork: [],
      showEnterModal: false,
      spinning: true,
    };
  },
  created() {
    this.courseId = this.$route.query.courseId;
    this.departId = this.$route.query.departId;
    this.getCourseUnit();
    this.getCourseInfo();
  },
  methods: {
    getCourseInfo() {
      getMineCourse({courseId: this.courseId}).then((res) => {
        this.courseInfo = res.result.records[0];
      });
    },
    getCourseUnit() {
      getStudentCourseUnit(this.departId, this.courseId, 1, 99).then((res) => {
        if (res.success) {
          this.spinning = false;
          this.courseUnitResult = res.result;
          this.unFinishedWork = res.result.records.filter((x) => {
            return x.mineWorkId == null;
          });
          this.finishedWork = res.result.records.filter((x) => {
            return x.mineWorkId != null;
          });
        }
      });
    },
    viewUnit(unit) {
      this.showEnterModal = true;
      this.currentUnit = unit;
    },
    toUnit() {
      let unit = this.currentUnit;
      if (unit.openTime == null || unit.serverTime < unit.openTime) {
        return;
      }
      this.$router.push({
        path: `/center/classroom?unitId=${unit.id}&courseId=${this.courseId}&departId=${this.departId}`,
      });
    },
    isPoint(index, unit) {
      if (unit.isOpen) {
        let list = this.courseUnitResult.records;
        let maxIndex = 0;
        for (var i = 0; i < list.length; i++) {
          if (list[i].isOpen) {
            maxIndex = i;
          }
        }
        if (maxIndex == index) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="less">
</style>